import $ from 'jquery';

// Expose jQuery globalement AVANT que main.js n'importe les plugins legacy
// (owl.carousel...) qui s'attachent a window.jQuery/window.$ plutot que de
// suivre le pattern UMD - sans ca ils creeraient/chercheraient une instance
// separee du $ utilise dans le reste du bundle webpack.
window.jQuery = $;
window.$ = $;

export default $;
